<app-page-title [title]="'Resources'"></app-page-title>
<div class="resources-link">
    <div class="row headingRow">
        <div class="col-md-6">
            <ul>
                <li *ngFor="let resource of resourceLinks">
                    <a
                        href="{{resource.link}}"
                        target="{{'_blank'}}"
                    >{{resource.title}}</a>
                </li>
            </ul>
        </div>
        <div
            *ngIf="marketingAd"
            class="col-md-6"
        >
            <a
                [ngClass]="{'marketAdLink' : !marketingAd.isClickable}"
                *ngIf="marketingAd.isActive && marketingAd.hasImageFile"
                target="{{(marketingAd.shouldOpenInNewWindow)? '_blank' : '_self' }}"
                href="{{marketingAd.adLink}}"
            ><img
                    src="{{marketingAdImage}}"
                    width="300"
                /></a>
        </div>
    </div>
</div>
